/**
 * @desc getAllocationDetail
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.allocationFacadeImpl.getAllocationDetail.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/allocation/getAllocationDetail`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
